import { SVGProps } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { useStyledTheme } from '../../styling';

const Icon = styled.div<{ small: boolean }>`${({ theme, small }) => `
  width: ${small ? theme.fontSize[3] : theme.fontSize[7]};
  height: ${small ? theme.fontSize[3] : theme.fontSize[7]};
`}`;

type IconValidatorProps = SVGProps<SVGSVGElement> & {
  small?: boolean,
  inverted?: boolean,
}

type ValidationIconProps = {
  small?: boolean,
  valid?: boolean,
  inverted?: boolean,
  readOnly?: boolean
}

export function ValidIcon({ small = false, inverted = false }: IconValidatorProps) {
  const theme = useStyledTheme();

  return (
    <Icon small={small}>
      <svg
        style={{ width: 'inherit', height: 'inherit' }}
        viewBox="-1 -1 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.333374 6.99992C0.333374 3.31802 3.31814 0.333252 7.00004 0.333252C10.6819 0.333252 13.6667 3.31802 13.6667 6.99992C13.6667 10.6818 10.6819 13.6666 7.00004 13.6666C3.31814 13.6666 0.333374 10.6818 0.333374 6.99992ZM10.1096 4.83498C10.3848 5.07959 10.4096 5.50097 10.165 5.77619L6.60944 9.77619C6.48291 9.91852 6.30157 9.99992 6.11117 9.99992C5.92071 9.99992 5.73937 9.91852 5.61288 9.77619L3.8351 7.77619C3.59049 7.50099 3.61527 7.07958 3.89047 6.83498C4.16565 6.59038 4.58703 6.61518 4.83165 6.89032L6.11117 8.32978L9.16844 4.89035C9.41304 4.61515 9.83444 4.59036 10.1096 4.83498Z"
          fill={inverted ? theme.colours.neutral[10] : theme.colours.primary[1]}
        />
        <path
          d="M10.1096 4.83515C10.3847 5.07976 10.4095 5.50114 10.1649 5.77636L8.38713 7.77636L6.60937 9.77636C6.48283 9.91869 6.3015 10.0001 6.1111 10.0001C5.92063 10.0001 5.7393 9.91869 5.61281 9.77636L3.83503 7.77636C3.59041 7.50116 3.6152 7.07976 3.89039 6.83516C4.16558 6.59056 4.58696 6.61536 4.83157 6.89049L6.1111 8.32996L9.16837 4.89052C9.41297 4.61532 9.83437 4.59054 10.1096 4.83515Z"
          fill={inverted ? theme.colours.primary[1] : theme.colours.neutral[10]}
        />
      </svg>
    </Icon>
  );
}

export function InvalidIcon({ small = false }: IconValidatorProps) {
  const theme = useStyledTheme();

  return (
    <Icon small={small}>
      <svg
        style={{ width: 'inherit', height: 'inherit' }}
        viewBox="-1 -1 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.00004 0.333252C3.31814 0.333252 0.333374 3.31802 0.333374 6.99992C0.333374 10.6818 3.31814 13.6666 7.00004 13.6666C10.6819 13.6666 13.6667 10.6818 13.6667 6.99992C13.6667 3.31802 10.6819 0.333252 7.00004 0.333252Z"
          fill={theme.colours.secondary[1]}
        />
        <path
          d="M4.1953 4.19526C4.45565 3.93491 4.87776 3.93491 5.13811 4.19526L7.00004 6.0572L8.86197 4.19526C9.12231 3.93491 9.54444 3.93491 9.80477 4.19526C10.0651 4.45561 10.0651 4.87772 9.80477 5.13807L7.94284 7L9.80477 8.86193C10.0651 9.12227 10.0651 9.5444 9.80477 9.80473C9.54444 10.0651 9.12231 10.0651 8.86197 9.80473L7.00004 7.9428L5.13811 9.80473C4.87776 10.0651 4.45565 10.0651 4.1953 9.80473C3.93495 9.5444 3.93495 9.12227 4.1953 8.86193L6.05724 7L4.1953 5.13807C3.93495 4.87772 3.93495 4.45561 4.1953 4.19526Z"
          fill={theme.colours.neutral[10]}
        />
      </svg>
    </Icon>
  );
}
export function LockIcon({ small = false, inverted = false }: IconValidatorProps) {
  const theme = useStyledTheme();
  return (
    small ? (
      <Icon small={small}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M8.00002 2.66671C9.0985 2.66671 10 3.56823 10 4.66671V6.66671H6.00002V4.66671C6.00002 3.56823 6.90154 2.66671 8.00002 2.66671ZM11.3334 6.66671V4.66671C11.3334 2.83185 9.83488 1.33337 8.00002 1.33337C6.16516 1.33337 4.66669 2.83185 4.66669 4.66671V6.66671H4.00002C3.26364 6.66671 2.66669 7.26366 2.66669 8.00004V13.3334C2.66669 14.0698 3.26364 14.6667 4.00002 14.6667H12C12.7364 14.6667 13.3334 14.0698 13.3334 13.3334V8.00004C13.3334 7.26366 12.7364 6.66671 12 6.66671H11.3334Z" fill={inverted ? theme.colours.neutral[10] : theme.colours.neutral[5]} />
        </svg>
      </Icon>
    ) : (
      <Icon small={small}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 4C13.6477 4 15 5.35228 15 7V10H9V7C9 5.35228 10.3523 4 12 4ZM17 10V7C17 4.24772 14.7523 2 12 2C9.24771 2 7 4.24772 7 7V10H6C4.89543 10 4 10.8954 4 12V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V12C20 10.8954 19.1046 10 18 10H17Z" fill={inverted ? theme.colours.neutral[10] : theme.colours.neutral[6]} />
        </svg>
      </Icon>
    )
  );
}
export function ValidInvertedIcon({ small = false }: IconValidatorProps) {
  return <ValidIcon small={small} inverted />;
}

export function ValidationIcon({
  small = false, inverted = false, valid, readOnly,
}: ValidationIconProps) {
  if (_.isNil(valid)) {
    return <></>;
  }
  if (readOnly) {
    return <LockIcon small={small} />;
  }
  if (valid) {
    return <ValidIcon small={small} inverted={inverted} />;
  }
  return <InvalidIcon small={small} />;
}
